import { render, staticRenderFns } from "./WriteBlogComment.vue?vue&type=template&id=cd3c7d78&scoped=true&"
import script from "./WriteBlogComment.vue?vue&type=script&lang=js&"
export * from "./WriteBlogComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3c7d78",
  null
  
)

export default component.exports